// /auth/callback — пустой экран, AuthProvider уже обработал code в bootstrap.
// После signinCallback() AuthProvider программно очищает URL (history.replaceState).
// Этот компонент просто отрисует loading UI на доли секунды.
import { useEffect } from 'react'
import { useAuth } from '@dss/auth'
import { useNavigate } from '../../lib/router'
import { invitationReturnPath } from '../invitations/invitationReturn'

export function AuthCallback() {
  const { isAuthenticated, isLoading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate(invitationReturnPath() ?? '/me', { replace: true })
    }
  }, [isAuthenticated, isLoading, navigate])

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--color-text-secondary)',
        fontSize: 13,
      }}
    >
      Завершаем вход…
    </div>
  )
}
